import { loadScript } from './tools';

const selector = '[class^="reviewforest-app-"]';
const triggerSelector = '.footer-main';
const script = 'https://widgets.reviewforest.org/main.js';

if (document.querySelector(selector)) {
    const el = document.querySelector(triggerSelector);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            loadScript(script);
            observer.unobserve(el);
        }
    });

    observer.observe(el);
}
